// @flow
import { fetchBidderStatusesByIdIfNeeded, fetchHelpfulCountsByIdIfNeeded } from '../../../redux/modules/reviewStatus';
import {
    fetchSellerCommentsByIdIfNeeded,
    fetchSellerPercentilesByIdIfNeeded,
    fetchSellerRatingsByIdIfNeeded,
    getSellerRatingById,
} from '../../../redux/modules/sellerRatings';
import type { DataLoaderParams } from '../../../types/DataLoaderParams';
import { fetchSellersIfNeeded } from '../../../redux/modules/seller';
import { recordAnalyticsForSellerReviewsPageView } from '../../../redux/modules/analytics';

export default ({ location, match, store }: DataLoaderParams) => {
    const { params } = match;
    const id = params.sellerId;
    const { dispatch, getState } = store;
    const page = location?.query?.page || 1;
    const pageSize = location?.query?.pageSize || 50;
    const filter = location?.query?.filter || '';
    const sort = location?.query?.sort || '';
    const promises = [
        dispatch(fetchSellersIfNeeded([id])),
        dispatch(fetchSellerRatingsByIdIfNeeded({ filter, page, pageSize, sellerId: id, sort })),
        dispatch(fetchSellerPercentilesByIdIfNeeded(id)),
        dispatch(fetchSellerCommentsByIdIfNeeded(id)),
    ];
    return Promise.all(promises).then(() => {
        const state = getState();
        const rating = getSellerRatingById(state, id);
        if (Boolean(rating?.reviews)) {
            const ids = rating.reviews.map(r => r.reviewId);
            return Promise.all([
                dispatch(fetchBidderStatusesByIdIfNeeded(ids)),
                dispatch(fetchHelpfulCountsByIdIfNeeded(ids)),
            ]).then(() => {
                return dispatch(recordAnalyticsForSellerReviewsPageView(id));
            });
        } else {
            return dispatch(recordAnalyticsForSellerReviewsPageView(id));
        }
    });
};
